import React from "react";
import XIconRemoveButton from "../../../components/buttons/XIconRemoveButton";
import AirlinePaginatedDropdown from "components/dropdowns/paginated/AirlinePaginatedDropdown";

interface Props {
  airline: server.dto.Airline
  onAirlineChange: (airline: server.dto.Airline) => void
  error: boolean
}

const AirlineSelection = React.memo((props: Props) => {
  if (props.airline) {
    return <RemovableAirline airline={props.airline} onAirlineRemoved={() => { props.onAirlineChange(undefined); }} />;
  }

  return <AirlinePaginatedDropdown
    value={props.airline}
    onChange={props.onAirlineChange}
    config={{
      isSearchable: true,
      hasError: props.error
    }}
  />;
}, (prev, next) => {
  if (prev.error !== next.error) {
    return false;
  }

  if (prev.airline?.airlineId !== next.airline?.airlineId) {
    return false;
  }

  if (prev.onAirlineChange !== next.onAirlineChange) {
    return false;
  }

  return true;
});
AirlineSelection.displayName = "AirlineSelection";
export default AirlineSelection;

const RemovableAirline = (props: { airline: server.dto.Airline, onAirlineRemoved: () => void }) => <div className="flex gap">
  <XIconRemoveButton onClick={props.onAirlineRemoved} />
  <div className="flex-column">
    <span>{props.airline.name}</span>
    <div className="text-sublabel">{props.airline.friendlyCode}</div>
  </div>
</div>;
